import { STATE__generation } from '../STATE__generation';

export function FN_GENERATION__status_lock(state: STATE__generation, generation_id: string) {
  if (state.generation_ids_with_locked_status.has(generation_id)) return;

  state.generation_ids_with_locked_status.add(generation_id);

  //need to force re-render
  state.generation_ids_with_locked_status = new Set(state.generation_ids_with_locked_status);
}
